/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { CreateSettingsServiceApiArg, SettingsServiceItem } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    createSettingsService: build.mutation<SettingsServiceItem, CreateSettingsServiceApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/settings/services`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as createSettingsServiceApi };
export const { useCreateSettingsServiceMutation } = injectedRtkApi;
